import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import Header from './Header';
import Footer from './Footer';
import ProjectCard from './ProjectCard';
import { filterDisplayableImages, filterDisplayableProject, CM_MAHAL_GALLERY_PROJECTS } from '../utils/projectImages';
import './CompanyDetail.css';

const getFallbackData = (companyId) => {
    const companies = {
      'dhanalakshmi-engineers': {
        id: 'dhanalakshmi-engineers',
        name: 'Dhanalakshmi Engineers',
        service: 'BUILDERS, INTERIORS & PLANNERS',
        description: 'Leading builders with expertise in construction and development projects.',
        details: 'Dhanalakshmi Engineers is a premier construction company with over 25 years of excellence in residential, commercial, and institutional building projects. We deliver quality construction services with premium materials, skilled craftsmanship, and unwavering commitment to on-time delivery. Our expertise spans complete turnkey projects, ensuring your vision becomes reality with precision and reliability.',
        services: [
          'Residential Construction',
          'Commercial Buildings',
          'Infrastructure Development',
          'Project Management',
          'Quality Assurance'
        ],
        contact: {
          phone: '+91 9176253687',
          email: 'dhan.eng@cmgroups.in',
          address: 'CM Mahal, Jothi Nagar, Madambakkam, Chennai 603202'
        },
        projects: {
          residential: [
            {
              id: 7,
              name: 'Residence at Ambattur',
              year: 'Ongoing',
              value: '100',
              scope: 'Complete turnkey project',
              images: [
                '/images/projects/residential/residence-ambattur.jpg',
                '/images/projects/residential/residence-ambattur-2.jpg'
              ]
            },
            {
              id: 8,
              name: 'Residence at Kandigai',
              year: 'Ongoing',
              value: '60',
              scope: 'Complete turnkey project',
              images: [
                '/images/projects/residential/residence-kandigai.jpg',
                '/images/projects/residential/residence-kandigai-2.jpg'
              ]
            },
            {
              id: 1,
              name: 'Residence at Royapuram',
              year: '2021-22, 2023-24',
              value: '200, 350',
              scope: 'Complete turnkey project',
              images: [
                '/images/projects/residential/residence-royapuram-2023.jpg',
                '/images/projects/residential/residence-royapuram-2023-2.jpg',
                '/images/projects/residential/residence-royapuram-2023-3.jpg'
              ]
            },
            {
              id: 4,
              name: 'Pallava Granites, Chennai',
              year: '2012',
              value: '440',
              scope: 'A beach house of the company. Administrative office of the company',
              images: ['/images/projects/commercial/pallava-granites.jpg']
            },
            {
              id: 5,
              name: 'Redbrick Construction, Chennai',
              year: '2013',
              value: '220',
              scope: 'Construction of Stilt + 3 storey structure, Apartment in Korattur - about 12,000 sq.ft. constructed area',
              images: ['/images/projects/commercial/redbrick-construction.jpg']
            },
            {
              id: 2,
              name: 'Residence at MKB Nagar',
              year: '2021-22',
              value: '90',
              scope: 'Complete turnkey project',
              images: [
                '/images/projects/residential/residence-mkb-nagar.jpg',
                '/images/projects/residential/residence-mkb-nagar-2.jpg'
              ]
            },
            {
              id: 9,
              name: 'Residence at Thiruvothiyur',
              year: '2022-23',
              value: '120',
              scope: 'Complete turnkey project',
              images: ['/images/projects/residential/residence-thiruvothiyur.jpg']
            },
            {
              id: 10,
              name: 'Residence, Chennai',
              year: '2019',
              value: '90',
              scope: 'Construction of Ground + 2 storey structure, Residence',
              images: ['/images/projects/residential/residence-chennai.jpg']
            },
            {
              id: 11,
              name: 'Anand Apartments, Chennai',
              year: '2016-17',
              value: '120',
              scope: 'Construction of stilt + 2 storey structure, residence apartment in kolathur, Chennai',
              images: ['/images/projects/residential/anand-apartments.jpg']
            },
            {
              id: 6,
              name: 'Matt Home at Cuddalore',
              year: '2018-19',
              value: '',
              scope: 'Final Completion of the project',
              images: [
                '/images/projects/institutional/matt-home-cuddalore-1.jpg',
                '/images/projects/institutional/matt-home-cuddalore-2.jpg'
              ]
            }
          ],
          commercial: [
            {
              id: 21,
              name: 'Margheritaly Guest House, Thiruvannamalai for TDH core',
              year: '2018-19',
              value: '200',
              scope: 'Guest house construction',
              images: ['/images/projects/commercial/margheritaly-guest-house.jpg']
            },
            {
              id: 19,
              name: 'Kodaikanal Ecoresort',
              year: '2016-17',
              value: '450',
              scope: 'Eco-friendly resort construction',
              images: ['/images/projects/commercial/kodaikanal-ecoresort.jpg']
            },
            {
              id: 18,
              name: 'Lakshmisai cold storage 1 & 2',
              year: '2015-16',
              value: '280',
              scope: 'Construction of cold storage facility',
              images: [
                '/images/projects/commercial/cold-storage-1.jpg',
                '/images/projects/commercial/cold-storage-2.jpg'
              ]
            },
            {
              id: 25,
              name: 'Apartment at Sholinganalur',
              year: '2019-20',
              value: '300',
              scope: 'Apartment complex construction',
              images: ['/images/projects/commercial/apartment-sholinganalur.jpg']
            },
            {
              id: 20,
              name: 'Guest house at TDH Core trust',
              year: '2017-18',
              value: '180',
              scope: 'Guest house construction',
              images: ['/images/projects/commercial/tdh-guest-house.jpg']
            },
            {
              id: 16,
              name: 'Vishalam Builders Group Development, Kumbakonam',
              year: '2014-15',
              value: '350',
              scope: 'Construction of Stilt + 2 storey structure, Row houses for TDH Homes (Staff Quarters)',
              images: [
                '/images/projects/commercial/vishalam-builders-1.jpg',
                '/images/projects/commercial/vishalam-builders-2.jpg'
              ]
            },
            {
              id: 17,
              name: 'Row houses for TDH Homes (Staff Quarters)',
              year: '2014-15',
              value: '350',
              scope: 'Construction of Stilt + 2 storey structure, Row houses',
              images: ['/images/projects/commercial/tdh-row-houses.jpg']
            }
          ],
          institutional: [
            {
              id: 23,
              name: 'Shraddha Academy, Chennai',
              year: '2014-15',
              value: '320',
              scope: 'Educational institution construction',
              images: ['/images/projects/institutional/shraddha-academy.jpg']
            },
            {
              id: 24,
              name: 'Kurunchi Children\'s Home for TDH core',
              year: '2015-16',
              value: '250',
              scope: 'Children\'s home facility',
              images: ['/images/projects/institutional/kurunchi-children-home.jpg']
            },
            {
              id: 22,
              name: 'Nalanda International School, Salem',
              year: '2013-14',
              value: '380',
              scope: 'School building construction',
              images: ['/images/projects/institutional/nalanda-school.jpg']
            }
          ]
        }
      },
      'dev-design-studio': {
        id: 'dev-design-studio',
        name: 'Dev Design Studio',
        service: 'ARCHITECTURE & PLANNING',
        description: 'Innovative architectural solutions that blend functionality with aesthetic excellence.',
        details: 'Dev Design Studio provides comprehensive architectural, planning, and interior design solutions. We create innovative and functional spaces that reflect your vision and lifestyle. Our experienced architects and designers combine creativity with practicality to deliver stunning designs.',
        services: [
          'Architectural Design',
          'Interior Planning',
          'Space Planning',
          '3D Visualization'
        ],
        contact: {
          phone: '+91 9176253687',
          email: 'devdesignstudio@cmgroups.in',
          address: 'CM Mahal, Jothi Nagar, Madambakkam, Chennai 603202'
        }
      },
      'cm-homes': {
        id: 'cm-homes',
        name: 'CM Homes',
        service: 'REAL ESTATE PROMOTERS',
        description: 'Trusted real estate development with a proven track record.',
        details: 'CM Homes delivers trusted real estate promotion services, focusing on quality residential and commercial properties. We specialize in developing projects that meet the highest standards of quality, design, and value.',
        services: [
          'Residential Projects',
          'Commercial Development',
          'Property Investment',
          'Real Estate Consulting'
        ],
        contact: {
          phone: '+91 9176253687',
          email: 'cmhomes@cmgroups.in',
          address: 'CM Mahal, Jothi Nagar, Madambakkam, Chennai 603202'
        }
      },
      'cm-mahal': {
        id: 'cm-mahal',
        name: 'CM Mahal',
        service: 'MARRIAGE & PARTY HALL',
        description: 'Elegant venue for weddings and celebrations with world-class facilities.',
        details: 'CM Mahal is a premium wedding and party hall venue offering elegant spaces for your special occasions. With state-of-the-art facilities, exquisite interiors, and professional event management services, we ensure your celebrations are memorable.',
        services: [
          'Wedding Halls',
          'Party Venues',
          'Event Planning',
          'Catering Services',
          'Decoration Services',
          'Audio-Visual Equipment',
          'Parking Facilities'
        ],
        contact: {
          phone: '+91 9176253687',
          email: 'vigneshwar@cmgroups.in',
          address: 'CM Mahal, Jothi Nagar, Madambakkam, Chennai 603202'
        },
        projects: {
          gallery: CM_MAHAL_GALLERY_PROJECTS
        }
      },
      'cm-luxury-stays': {
        id: 'cm-luxury-stays',
        name: 'CM Luxury Stays',
        service: 'LUXURY HOSPITALITY',
        description: 'Premium accommodation experiences with world-class amenities and exceptional service.',
        details: 'CM Luxury Stays offers premium accommodation experiences with world-class amenities and exceptional service. We provide luxurious stays that combine comfort, elegance, and unmatched hospitality for discerning travelers.',
        services: [
          'Luxury Rooms',
          'Premium Suites',
          'Fine Dining',
          'Concierge Services',
          'Event Hosting',
          'Wellness & Recreation'
        ],
        contact: {
          phone: '+91 9176253687',
          email: 'info@cmgroups.in',
          address: 'CM Mahal, Jothi Nagar, Madambakkam, Chennai 603202'
        }
      }
    };
    return companies[companyId];
  };

const CompanyDetail = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // Get category from URL parameter, default to 'residential'
  const categoryFromUrl = searchParams.get('category');
  const [activeCategory, setActiveCategory] = useState(
    categoryFromUrl && ['residential', 'commercial', 'institutional'].includes(categoryFromUrl) 
      ? categoryFromUrl 
      : 'residential'
  );
  const [selectedProject, setSelectedProject] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [imageLoading, setImageLoading] = useState(true);

  const fetchCompanyDetails = useCallback(async () => {
    const fallbackData = getFallbackData(id);

    if (!fallbackData) {
      setCompany(null);
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get(`http://localhost:8080/api/companies/${id}`, {
        timeout: 2000
      });
      setCompany({
        ...response.data,
        ...fallbackData,
        contact: fallbackData.contact,
        projects: fallbackData.projects
      });
    } catch (error) {
      console.log('Backend not available, using fallback data');
      setCompany(fallbackData);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchCompanyDetails();
  }, [fetchCompanyDetails]);

  // Update active category when URL parameter changes and scroll to top
  useEffect(() => {
    const categoryFromUrl = searchParams.get('category');
    if (categoryFromUrl && ['residential', 'commercial', 'institutional'].includes(categoryFromUrl)) {
      setActiveCategory(categoryFromUrl);
    }
    // Scroll to top when category changes
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [searchParams]);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [id]);

  // Keyboard navigation - must be before early returns
  useEffect(() => {
    if (!selectedProject) return;

    const getProjectImages = (project) => {
      if (project.images && Array.isArray(project.images)) {
        return project.images;
      }
      if (project.image) {
        return [project.image];
      }
      return [];
    };

    const handleKeyPress = (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        const images = getProjectImages(selectedProject);
        setImageLoading(true);
        setCurrentImageIndex((prev) => (prev + 1) % images.length);
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        const images = getProjectImages(selectedProject);
        setImageLoading(true);
        setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
      } else if (e.key === 'Escape') {
        e.preventDefault();
        setSelectedProject(null);
        setCurrentImageIndex(0);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [selectedProject]);

  if (loading) {
    return (
      <div className="company-detail-page">
        <Header />
        <div className="loading-state">Loading...</div>
      </div>
    );
  }

  if (!company) {
    return (
      <div className="company-detail-page">
        <Header />
        <div className="error-state">Company not found</div>
      </div>
    );
  }

  const getProjectsForCategory = () => {
    if (id === 'dhanalakshmi-engineers' && company.projects) {
      return (company.projects[activeCategory] || [])
        .map(filterDisplayableProject)
        .filter(Boolean);
    }
    if (id === 'cm-mahal' && company.projects?.gallery) {
      return company.projects.gallery
        .map(filterDisplayableProject)
        .filter(Boolean);
    }
    return [];
  };

  const getProjectImages = (project) => {
    if (project.images && Array.isArray(project.images)) {
      return filterDisplayableImages(project.images);
    }
    if (project.image) {
      return filterDisplayableImages([project.image]);
    }
    return [];
  };

  const projects = getProjectsForCategory();

  const openGallery = (project) => {
    const images = getProjectImages(project);
    if (images.length > 0) {
      setSelectedProject(project);
      setCurrentImageIndex(0);
      setImageLoading(true);
    }
  };

  const closeGallery = () => {
    setSelectedProject(null);
    setCurrentImageIndex(0);
  };

  const nextImage = () => {
    if (selectedProject) {
      const images = getProjectImages(selectedProject);
      setImageLoading(true);
      setCurrentImageIndex((prev) => (prev + 1) % images.length);
    }
  };

  const prevImage = () => {
    if (selectedProject) {
      const images = getProjectImages(selectedProject);
      setImageLoading(true);
      setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
    }
  };

  const getCategoryTitle = () => {
    if (id === 'cm-mahal') return 'Our Venue Gallery';
    if (activeCategory === 'residential') return 'Residential Projects';
    if (activeCategory === 'commercial') return 'Commercial Projects';
    if (activeCategory === 'institutional') return 'Institutional Projects';
    return 'Projects';
  };

  return (
    <div className="company-detail-page">
      <Header />
      
      <div className="company-detail-container">
        {/* Company Header */}
        <div className="company-header-section">
          <h1 className="company-title">{company.name}</h1>
          <div className="company-service-badge">{company.service}</div>
          {company.details && (
            <p className="company-description">{company.details}</p>
          )}
        </div>

        {/* Category Tabs - Only show for Dhanalakshmi Engineers */}
        {id === 'dhanalakshmi-engineers' && company.projects && (
          <div className="category-tabs-wrapper">
            <button
              className={`category-tab-btn ${activeCategory === 'residential' ? 'active' : ''}`}
              onClick={() => setActiveCategory('residential')}
            >
              Residential Projects
            </button>
            <button
              className={`category-tab-btn ${activeCategory === 'commercial' ? 'active' : ''}`}
              onClick={() => setActiveCategory('commercial')}
            >
              Commercial Projects
            </button>
            <button
              className={`category-tab-btn ${activeCategory === 'institutional' ? 'active' : ''}`}
              onClick={() => setActiveCategory('institutional')}
            >
              Institutional Projects
            </button>
          </div>
        )}

        {/* Projects Gallery */}
        {(id === 'dhanalakshmi-engineers' || id === 'cm-mahal') && company.projects && projects.length > 0 && (
          <div className={`projects-section ${id === 'cm-mahal' ? 'projects-section-images-only' : ''}`}>
            {id !== 'cm-mahal' && (
              <h2 className="projects-section-title">{getCategoryTitle()}</h2>
            )}
            <div className={`projects-grid ${id === 'cm-mahal' ? 'projects-grid-images-only' : ''}`}>
              {projects.map((project) => (
                <ProjectCard 
                  key={project.id}
                  project={project}
                  onClick={openGallery}
                  imageOnly={id === 'cm-mahal'}
                />
              ))}
            </div>
          </div>
        )}

        {/* Image Gallery Modal */}
        {selectedProject && (
          <div className="gallery-modal-overlay" onClick={closeGallery}>
            <div className="gallery-modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="gallery-close-button" onClick={closeGallery}>×</button>
              <div className="gallery-header-info">
                {selectedProject.name && (
                  <h3 className="gallery-project-title">{selectedProject.name}</h3>
                )}
                <div className="gallery-image-counter">
                  {currentImageIndex + 1} / {getProjectImages(selectedProject).length}
                </div>
              </div>
              <div className="gallery-image-wrapper">
                <button className="gallery-nav-button gallery-prev-button" onClick={prevImage}>‹</button>
                <img 
                  src={getProjectImages(selectedProject)[currentImageIndex]} 
                  alt={`${selectedProject.name} - ${currentImageIndex + 1}`}
                  className={`gallery-main-image ${!imageLoading ? 'fade-in' : ''}`}
                  onLoad={() => setImageLoading(false)}
                  onError={(e) => {
                    e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjMWExYTJlIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtc2l6ZT0iMTgiIGZpbGw9IiNmZmYiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj5JbWFnZSBDb21pbmcgU29vbg==';
                    setImageLoading(false);
                  }}
                />
                <button className="gallery-nav-button gallery-next-button" onClick={nextImage}>›</button>
              </div>
              <div className="gallery-thumbnails-wrapper">
                {getProjectImages(selectedProject).map((img, idx) => (
                  <img
                    key={idx}
                    src={img}
                    alt={`Thumbnail ${idx + 1}`}
                    className={`gallery-thumbnail-item ${idx === currentImageIndex ? 'active' : ''}`}
                    onClick={() => {
                      setImageLoading(true);
                      setCurrentImageIndex(idx);
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        )}

        {company.contact && (
          <div className="company-contact-section">
            <h2 className="company-contact-title">Contact Us</h2>
            <div className="company-contact-details">
              {company.contact.phone && (
                <p>
                  <strong>Phone:</strong>{' '}
                  <a href={`tel:${company.contact.phone.replace(/\s/g, '')}`}>{company.contact.phone}</a>
                </p>
              )}
              {company.contact.email && (
                <p>
                  <strong>Email:</strong>{' '}
                  <a href={`mailto:${company.contact.email}`}>{company.contact.email}</a>
                </p>
              )}
              {company.contact.address && (
                <p>
                  <strong>Address:</strong> {company.contact.address}
                </p>
              )}
            </div>
          </div>
        )}

        {/* Show services content for non-project companies */}
        {id !== 'dhanalakshmi-engineers' && id !== 'cm-mahal' && (
          <div className="other-companies-grid">
            <div className="other-company-card">
              <div className="other-company-badges">
                {company.services && company.services.slice(0, 2).map((service, index) => (
                  <span key={index} className="other-company-badge">{service}</span>
                ))}
              </div>
              <h2 className="other-company-title">Our Services</h2>
              <p className="other-company-description">
                {company.details || company.description}
              </p>
            </div>

            {company.services && company.services.length > 2 && (
              <div className="other-company-card">
                <div className="other-company-badges">
                  {company.services.slice(2, 4).map((service, index) => (
                    <span key={index + 2} className="other-company-badge">{service}</span>
                  ))}
                </div>
                <h2 className="other-company-title">Additional Services</h2>
                <p className="other-company-description">
                  We provide comprehensive solutions to meet all your construction and development needs with excellence and precision.
                </p>
              </div>
            )}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default CompanyDetail;
